export const DEFAULT_LEXICON = "DEFAULT";
export const GAMING_LEXICON = "GAMING";

export const lexicons = [DEFAULT_LEXICON, GAMING_LEXICON];
